export class DriverViewModel {
  id: string;
  driverNo: string;
  name: string;
  middleName: string;
  lastName: string;
  displayName: string;
  email: string;
  altEmail: string;
  cellphone: string;
  phone: string;
  birthDate: Date;
  hiredDate: Date;
  hiredDateTo: Date;
  licenseNumber: string;
  licenseState: string;
  licenseExpirationDate: Date;
  homeAddress: string;
  city: string;
  state: string;
  zipCode: string;
  emergencyContName: string;
  emergencyContPhone: string;
  taxId: string;
  manager: string;
  operatorId: string;
  driverId: string;
  lessorId: string;
  type: string;
  avatarDriverType: string;
  terminationType: string;
  socialSecurityNumber: string;
  physicalExamDate: Date;
  physicalExamExpirationDate: Date;
  annualReviewDate: Date;
  trainingDateCGMP: Date;
  expirationDateCGMP: Date;
  hazmatTrainingDate: Date;
  hazmatTrainingExpirationDate: Date;
  hmeExpirationDate: Date;
  passportExpirationDate: Date;
  bonusPerMile: number;
  peopleNetId: string;
  terminated: boolean;
  terminationDate: Date;
  details: string;
  isActive: boolean;
  rehire: boolean;
  tchekCardNo?: string;
  isPayTo: boolean;
  isPtoEligible?: boolean | null;
  isPtoEligibleDefault?: boolean | null;
  earningPercentage: number;
  settlementEmail: string;
  picture: string;
  efsDriverId?: string;
  isOffToday?: boolean;

  driverHireDates: any[];
  team: any;
  teamId?: string;
  tractors: any[];

  // compliance
  doNotDispatch?: boolean;
  outOfCompliance?: boolean;
  productQualifications?: DriverProductQualification[];
  customerTraining?: DriverCustomerTraining[];
  inDepthSecurityExpirationDate?: Date;
  twicCardExpirationDate?: Date;
  autoTransmissionOnly?: boolean;
  lastAvatarSyncDate?: Date;

  // notes
  notes?: DriverNote[];

  // assignments
  tractorId?: string;
  trailerId?: string;
  clientId?: string;
  billToId?: string;
  specialNote?: string;

  // scheduling team assignments
  schedulingTeamName?: string;
  billToClientName?: string;
  boardName?: string;

  preferredClients?: DriverPreferredClient[];
  bannedClients?: DriverBannedClient[];
  preferredAreas?: DriverPreferredArea[];
  assignmentHistory?: DriverAssignmentHistory[];

  // client only
  previousTeam: any;
}

export interface DriverPreferredClient {
  id?: string;
  driverId?: string;
  clientId: string;
  clientName?: string;
  customerNo?: string;
}

export interface DriverBannedClient {
  id?: string;
  driverId?: string;
  clientId: string;
  clientName?: string;
  customerNo?: string;
}

export interface DriverPreferredArea {
  id?: string;
  driverId?: string;
  gasRegionId: string;
  regionName?: string;
}

export interface DriverAssignmentHistory {
  id?: string;
  driverId?: string;
  date: Date;
  type: string;
  assignedTo: string;
  user: string;
}

export interface DriverProductQualification {
  id?: string;
  driverId?: string;
  productQualificationId: string;
  productQualificationName?: string;
  productQualificationAvatarFieldName?: string;
  qualification?: string;
}

export interface DriverCustomerTraining {
  id?: string;
  driverId?: string;
  trainingName: string;
  qualification?: string;
}

export interface DriverNote {
  id?: string;
  driverId?: string;
  driverName?: string;
  driverNo?: string;
  note?: string;
  status?: string;
  type?: string;
  dateCreatedUtc?: Date;
  createdByUserId?: string;
  createdByUserName?: string;

  // Accident/Incident fields
  anyInjuries?: boolean;
  anotherVehicleInvolved?: boolean;
  driverCitation?: boolean;
  citationDescription?: string;
  tractorId?: string;
  tractorNumber?: string;
  trailerId?: string;
  trailerNumber?: string;
  loadedEmpty?: string;
  productId?: string;
  productName?: string;
  accidentDate?: string;
  accidentTime?: string;
  accidentCity?: string;
  accidentState?: string;
  accidentLocation?: string;
  weather?: string;
  accidentDescription?: string;
  damageDescription?: string;
  assignedCustomer?: string;
  photosToSafety?: string;
  spokenWithThirdParty?: boolean;
  thirdPartyContactName?: string;

  // Delay/Breakdown fields
  clientId?: string;
  clientName?: string;
  billToId?: string;
  billToName?: string;
  tripNumber?: string;
  customerReferenceNumber?: string;
  eta?: string;
  truckTrailerIssue?: string;
  hosRemaining?: number;
  internalNotes?: string;
  clientNotes?: string;
  roadCallNumber?: string;

  // Driver Release fields
  driverLocation?: string;
  requestTimeOff?: boolean;
  trailerDropoffLocation?: string;
  nextAvailable?: string;

  // Common optional field
  followUpDate?: Date;

  // Email tracking fields
  emailedToSafety?: Date;
  emailedFormToDriver?: Date;
  emailedToClient?: Date;
  emailedToDriver?: Date;
}
